import React from 'react';
import { useSettings } from '@/contexts/SettingsContext';
import { Instagram, Facebook, MapPin, ArrowUpRight } from 'lucide-react';
import { Logo } from './Logo';
import { PUBLIC_MENU_ENABLED } from '@/lib/launchMode';

export const SiteFooter = () => {
  const { settings } = useSettings();
  if (!settings) return null;
  const directions = settings.social_links?.google_directions
    || `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(settings.address || 'Smithy Browns Milton Keynes')}`;
  return (
    <footer className="bg-black border-t border-[hsl(var(--sb-border))] mt-10 pb-24 lg:pb-8">
      <div className="sb-flag-stripes" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 grid grid-cols-1 md:grid-cols-3 gap-6 text-white">
        <div>
          <Logo variant="header" />
          <p className="text-sm text-white/70 mt-3 max-w-xs">{settings.tagline}</p>
        </div>

        <div>
          <h4 className="font-display text-lg text-[hsl(var(--sb-gold))]">Find Us</h4>
          <div className="text-sm text-white/85 mt-2 flex items-start gap-2">
            <MapPin size={16} className="mt-0.5 text-[hsl(var(--sb-gold))]" />
            <div>
              <div>Bletchley, Milton Keynes</div>
              <div className="text-white/60 text-xs">{settings.address}</div>
              <a
                href={directions}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-flex items-center gap-1 text-sm text-[hsl(var(--sb-gold))] hover:underline"
                data-testid="footer-directions-link"
              >
                Get Directions <ArrowUpRight size={14} />
              </a>
            </div>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg text-[hsl(var(--sb-gold))]">Follow</h4>
          <div className="flex gap-3 mt-3">
            {settings.social_links?.instagram && (
              <a href={settings.social_links.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-9 w-9 inline-flex items-center justify-center rounded-full border border-[hsl(var(--sb-border))] hover:border-[hsl(var(--sb-gold))]"><Instagram size={16} /></a>
            )}
            {settings.social_links?.facebook && (
              <a href={settings.social_links.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-9 w-9 inline-flex items-center justify-center rounded-full border border-[hsl(var(--sb-border))] hover:border-[hsl(var(--sb-gold))]"><Facebook size={16} /></a>
            )}
            {settings.social_links?.tiktok && (
              <a href={settings.social_links.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" className="h-9 w-9 inline-flex items-center justify-center rounded-full border border-[hsl(var(--sb-border))] hover:border-[hsl(var(--sb-gold))] text-xs font-bold">TT</a>
            )}
          </div>
          <div className="mt-4 flex gap-4 text-xs text-white/55">
            {PUBLIC_MENU_ENABLED && <a href="/menu" className="hover:text-white">Menu</a>}
            <a href="/book" className="hover:text-white">Book a Table</a>
          </div>
        </div>
      </div>
      <div className="border-t border-[hsl(var(--sb-border))] py-4 text-center text-xs text-white/50">
        &copy; {new Date().getFullYear()} Smithy Browns &middot; Halal &middot; Milton Keynes
      </div>
    </footer>
  );
};
